import { Link } from "react-router-dom";

const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|[\w.+-]+@[\w-]+(?:\.[\w-]+)+)/g;

const inline = (text) =>
  text.split(INLINE).filter(Boolean).map((part, i) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) return <Link key={i} to={link[2]} className="text-coral-dark underline underline-offset-2">{link[1]}</Link>;
    if (part.startsWith("**")) return <strong key={i} className="font-semibold text-ink">{part.slice(2, -2)}</strong>;
    if (/^[\w.+-]+@[\w-]+(?:\.[\w-]+)+$/.test(part)) return <a key={i} href={`mailto:${part}`} className="text-coral-dark underline underline-offset-2">{part}</a>;
    return part;
  });

const cells = (row) => row.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());

function parse(md) {
  const lines = md.split("\n");
  const blocks = [];
  let i = 0;
  while (i < lines.length) {
    const l = lines[i];
    if (!l.trim()) { i++; continue; }
    if (l.startsWith("## ")) { blocks.push({ t: "h2", v: l.slice(3) }); i++; continue; }
    if (l.startsWith("# ")) { blocks.push({ t: "h1", v: l.slice(2) }); i++; continue; }
    if (l.startsWith("|")) {
      const rows = [];
      while (i < lines.length && lines[i].startsWith("|")) rows.push(lines[i++]);
      blocks.push({ t: "table", head: cells(rows[0]), body: rows.slice(2).map(cells) });
      continue;
    }
    if (l.startsWith("- ")) {
      const items = [];
      while (i < lines.length && lines[i].startsWith("- ")) items.push(lines[i++].slice(2));
      blocks.push({ t: "ul", v: items });
      continue;
    }
    const para = [];
    while (i < lines.length && lines[i].trim() && !/^(#|\||- )/.test(lines[i])) para.push(lines[i++]);
    blocks.push({ t: "p", v: para.join(" ") });
  }
  return blocks;
}

export const MiniMarkdown = ({ source }) => (
  <div className="text-[15px] leading-relaxed text-slate-700">
    {parse(source).map((b, k) => {
      if (b.t === "h1") return <h1 key={k} className="font-serif text-4xl sm:text-5xl font-extrabold text-ink leading-tight mb-6">{b.v}</h1>;
      if (b.t === "h2") return <h2 key={k} className="font-serif text-2xl font-bold text-ink mt-12 mb-4">{b.v}</h2>;
      if (b.t === "ul") return <ul key={k} className="list-disc pl-6 space-y-2 my-4">{b.v.map((it, j) => <li key={j}>{inline(it)}</li>)}</ul>;
      if (b.t === "table") return (
        <div key={k} className="overflow-x-auto my-6 rounded-lg border border-black/10" data-testid={`policy-table-${k}`}>
          <table className="w-full min-w-[560px] text-sm border-collapse">
            <thead className="bg-[#F4F1EC]"><tr>{b.head.map((h, j) => <th key={j} className="text-left font-semibold text-ink px-4 py-3 border-b border-black/10">{h}</th>)}</tr></thead>
            <tbody>{b.body.map((r, j) => <tr key={j} className="align-top">{r.map((c, n) => <td key={n} className="px-4 py-3 border-b border-black/5">{inline(c)}</td>)}</tr>)}</tbody>
          </table>
        </div>
      );
      return <p key={k} className="my-4">{inline(b.v)}</p>;
    })}
  </div>
);

export default MiniMarkdown;
